import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=6d63aa0a&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"
import style0 from "./Modify.vue?vue&type=style&index=0&id=6d63aa0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports